import { useContext } from "react";

import ToastContext from "components/atoms/toast/ToastContext";

const useToast = () => useContext(ToastContext);

export default useToast;
